/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AdminPageHeader } from '../Common/AdminPagesHeader';
import { DOCUMENT_CATEGORY, DOCUMENT_CATEGORY_COLUMNS } from '../../../constants';
import { Table, DocumentCategoryAddEdit } from '../../shared';
import { usePagination } from '../../../hooks';
import { getAllDocumentCategory, popup, getOneDocumentCategory } from '../../../utils';
import { QUERY_KEYS } from '../../../constants/queryKey';
import { useQuery } from '@tanstack/react-query';
import { useDebouncedValue } from '../../../hooks/useDebounceValue';

export const DocumentCategoryListing = () => {
    const location = useLocation();
    let { state } = location;
    const [response, setResponse] = useState({ data: [], count: 0 });
    const [search, setSearch] = useState('');
    const pagination = usePagination(response.data.length, response.count);
    const [openEditModal, setOpenEditModal] = useState(false);

    const handleAddClick = () => {
        setOpenEditModal(true);
    };

    const oneDocumentCategoryQuery = useQuery({
        queryKey: [QUERY_KEYS.DOCUMENT_CATEGORY_BY_ID, state?.id],
        queryFn: () => getOneDocumentCategory(state?.id),
        enabled: !!state?.id,
        placeholderData: { data: [], count: 0 },
    });

    const [debouncedSearch] = useDebouncedValue(search, 500);
    const documentCategoriesQuery = useQuery({
        queryKey: [
            QUERY_KEYS.DOCUMENT_CATEGORY,
            pagination.offset,
            pagination.limit,
            debouncedSearch,
        ],
        queryFn: () =>
            getAllDocumentCategory({
                offset: pagination.offset,
                limit: pagination.limit,
                search: debouncedSearch,
            }),
        enabled: !state?.id,
        placeholderData: { data: [], count: 0 },
    });

    if (oneDocumentCategoryQuery.isError) {
        popup('error', oneDocumentCategoryQuery.error?.message);
    }

    if (documentCategoriesQuery.isError) {
        popup('error', documentCategoriesQuery.error?.message);
    }

    useEffect(() => {
        if (!!state?.id && oneDocumentCategoryQuery.data) {
            setResponse({
                data: [{ ...oneDocumentCategoryQuery.data.data, id: state.id }],
                count: 1,
            });
        }
        if (!state?.id && documentCategoriesQuery.data) {
            setResponse({
                data: documentCategoriesQuery.data.data,
                count: documentCategoriesQuery.data.count,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documentCategoriesQuery.data, oneDocumentCategoryQuery.data, state?.id]);

    return (
        <>
            <AdminPageHeader
                heading={DOCUMENT_CATEGORY.PAGE_HEADING}
                buttonText={DOCUMENT_CATEGORY.BUTTON_TEXT}
                searchBarPlaceholder={DOCUMENT_CATEGORY.SEARCH_BAR_PLACEHOLDER}
                setSearch={setSearch}
                count={pagination.dataCount}
                showAddButton
                setResponse={setResponse}
                handleAddClick={handleAddClick}
                AddModal={
                    openEditModal ? (
                        <DocumentCategoryAddEdit
                            openEditModal={openEditModal}
                            setOpenEditModal={setOpenEditModal}
                            isEdit={false}
                            setResponse={setResponse}
                        />
                    ) : (
                        ''
                    )
                }
                setCurrentPage={pagination.setCurrentPage}
                backbutton
            />
            <Table
                columns={DOCUMENT_CATEGORY_COLUMNS}
                data={response.data}
                isLoading={
                    documentCategoriesQuery.isFetching || oneDocumentCategoryQuery.isFetching
                }
                pagination={pagination}
                pageName={DOCUMENT_CATEGORY.PAGE_NAME}
                stickyColumns={['Documents Categories']}
            />
        </>
    );
};
